import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  search<T extends { userName: string, userFirstName: string, visible: boolean}>(items: T[], filter: string): T[] {
    if (filter) {
      const filterArr = filter.trim().split(' ');

      items.forEach(item => {
        let visible = true;
        for (const index in filterArr) {
          const criteria = filterArr[index].trim().toUpperCase();
          visible = visible && (item.userName.toUpperCase().indexOf(criteria) !== -1 || item.userFirstName.toUpperCase().indexOf(criteria) !== -1);
        }
        item.visible = visible;
      });

      return items;
    }
    return items;
  }
}
